import React from 'react';
import bg from '../assets/background.jpg';

const contacts = [
  {
    title: 'Markkinavastaava',
    subtitle: 'Turvallisuusvastaava',
    name: 'Matti Vira',
    phone: '0400 995 765',
    email: 'matti.vira@gmail.com',
  },
  {
    title: 'SPR',
    subtitle: 'Ensiapuvastaava',
    name: 'Elina Junnila',
    phone: '050 342 8683',
  },
  {
    title: 'Paikkamyynti',
    name: 'Tommi Lautanala',
    phone: '050 363 9848',
    email: 'laurinmarkkinat@lcmynamaki.fi',
  },
  {
    title: 'Sähkövastaava',
    name: 'Jari Lehto',
    phone: '040 544 8172',
  },
  {
    title: 'Turvallisuusvastaavan varahenkilö',
    name: 'Kaj Kynäslahti',
    phone: '040 841 4496',
    email: 'kaitsukky@gmail.com',
  },
  {
    title: 'Mynämäen kunta',
    subtitle: 'Terveystarkastaja',
    name: 'Riitta Laaksonen',
    phone: '0400 293 887',
    email: 'riitta.laaksonen@uusikaupunki.fi',
  },
];

export const Contacts = () => {
  return (
    <div
      className="relative min-h-screen overflow-hidden bg-slate-900 bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${bg})` }}
    >
      <div className="absolute inset-0 bg-slate-950/65" />

      <div className="relative mx-auto max-w-6xl px-4 py-10 sm:px-6 lg:px-8">
        <div className="mb-8 rounded-3xl border border-white/20 bg-white/10 p-6 text-center text-white shadow-2xl backdrop-blur-sm sm:p-8">
          <h1 className="text-3xl font-black sm:text-4xl">Yhteystiedot</h1>
          <p className="mt-2 text-sm text-slate-100 sm:text-base">
            Täältä löydät Laurin markkinoiden tärkeimmät yhteyshenkilöt nopeasti.
          </p>
        </div>

        <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-3">
          {contacts.map((contact) => (
            <div
              key={`${contact.title}-${contact.name}`}
              className="rounded-2xl border border-slate-200/80 bg-white/90 p-5 text-slate-800 shadow-xl backdrop-blur-sm transition-transform duration-200 hover:-translate-y-1"
            >
              <div className="mb-3">
                <h2 className="text-xl font-bold text-slate-900">{contact.title}</h2>
                {contact.subtitle ? <p className="text-sm font-semibold text-sky-700">{contact.subtitle}</p> : null}
              </div>

              <div className="space-y-1 text-sm sm:text-base">
                <p className="font-semibold">{contact.name}</p>
                <p>
                  <a className="text-slate-700 hover:text-sky-700" href={`tel:${contact.phone.replace(/\s+/g, '')}`}>
                    {contact.phone}
                  </a>
                </p>
                {contact.email ? (
                  <p>
                    <a className="break-all text-sky-700 underline underline-offset-2" href={`mailto:${contact.email}`}>
                      {contact.email}
                    </a>
                  </p>
                ) : null}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 grid gap-5 lg:grid-cols-[1.2fr_0.8fr]">
          <div className="rounded-2xl border border-red-200 bg-white/90 p-6 text-center shadow-xl">
            <h2 className="text-xl font-bold text-slate-900">Yleinen hätänumero</h2>
            <p className="mt-3 text-5xl font-black text-red-600">112</p>
          </div>

          <div className="rounded-2xl border border-slate-200/80 bg-white/90 p-6 text-center shadow-xl">
            <h2 className="text-xl font-bold text-slate-900">Sivuston ylläpito</h2>
            <p className="mt-3">
              <a className="text-sky-700 underline underline-offset-2" href="mailto:info@lcmynamaki.fi">
                info@lcmynamaki.fi
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
